import { validationErrors } from 'utils';
import propTypeModels from 'propTypeModels';

import {
  GET_ME,
  GET_ME_SUCCESS,
  GET_ME_FAILED,

  GET_PROFILE_EXTRANET,
  GET_PROFILE_EXTRANET_SUCCESS,
  GET_PROFILE_EXTRANET_FAILED,

  UPDATE_ME,
  UPDATE_ME_SUCCESS,
  UPDATE_ME_FAILED,

  UPDATE_MY_AVATAR,
  UPDATE_MY_AVATAR_SUCCESS,
  UPDATE_MY_AVATAR_FAILED,

  DELETE_MY_AVATAR,
  DELETE_MY_AVATAR_SUCCESS,
  DELETE_MY_AVATAR_FAILED,

  UPDATE_MY_PASSWORD,
  UPDATE_MY_PASSWORD_SUCCESS,
  UPDATE_MY_PASSWORD_FAILED,

  LOGOUT,

  REFRESH_TOKEN_FAILED,
} from './actionTypes';

const initialState = {
  loading: false,
  loadingProfileExtranet: false,
  loadingAvatar: false,
  loadingPassword: false,
  loadingUpdate: false,

  me: propTypeModels.user.defaultData,
  profileExtranet: {},
  passwordError: {},
  error: {},
};

const userProfile = (state = initialState, action) => {
  switch (action.type) {
    // GET MY PROFILE
    case GET_ME:
      return {
        ...state,
        loading: true,
      };

    case GET_ME_SUCCESS:
      return {
        ...state,
        loading: false,
        me: action.payload,
      };

    case GET_ME_FAILED:
      return {
        ...state,
        loading: false,
        me: initialState.me,
      };

    // GET PROFILE EXTRANET
    case GET_PROFILE_EXTRANET:
      return {
        ...state,
        loadingProfileExtranet: true,
      };

    case GET_PROFILE_EXTRANET_SUCCESS:
      return {
        ...state,
        loadingProfileExtranet: false,
        profileExtranet: action.payload,
        me: action.payload,
      };

    case GET_PROFILE_EXTRANET_FAILED:
      return {
        ...state,
        loadingProfileExtranet: false,
        profileExtranet: initialState.profileExtranet,
        me: initialState.me,
      };

    // UPDATE MY PROFILE
    case UPDATE_ME:
      return {
        ...state,
        loadingUpdate: true,
        error: propTypeModels.user.defaultData,
      };

    case UPDATE_ME_SUCCESS:
      return {
        ...state,
        loadingUpdate: false,
        me: action.payload,
      };

    case UPDATE_ME_FAILED:
      return {
        ...state,
        loadingUpdate: false,
        error: validationErrors(action.payload),
      };

    // UPDATE MY AVATAR
    case UPDATE_MY_AVATAR:
      return {
        ...state,
        loadingAvatar: true,
      };

    case UPDATE_MY_AVATAR_SUCCESS:
      return {
        ...state,
        loadingAvatar: false,
        me: {
          ...state.me,
          avatar: action.payload.avatar,
        },
      };

    case UPDATE_MY_AVATAR_FAILED:
      return {
        ...state,
        loadingAvatar: false,
      };

      // DELETE MY AVATAR
    case DELETE_MY_AVATAR:
      return {
        ...state,
        loadingAvatar: true,
      };

    case DELETE_MY_AVATAR_SUCCESS:
      return {
        ...state,
        loadingAvatar: false,
        me: {
          ...state.me,
          avatar: '',
        },
      };

    case DELETE_MY_AVATAR_FAILED:
      return {
        ...state,
        loadingAvatar: false,
      };

    // UPDATE MY PASSWORD
    case UPDATE_MY_PASSWORD:
      return {
        ...state,
        loadingPassword: true,
        passwordError: {},
      };

    case UPDATE_MY_PASSWORD_SUCCESS:
      return {
        ...state,
        loadingPassword: false,
      };

    case UPDATE_MY_PASSWORD_FAILED:
      return {
        ...state,
        loadingPassword: false,
        passwordError: validationErrors(action.payload),
      };

    // LOGOUT
    case LOGOUT: {
      return {
        ...state,
        me: initialState.me,
        profileExtranet: initialState.profileExtranet,
      };
    }

    case REFRESH_TOKEN_FAILED:
      return {
        ...state,
        me: initialState.me,
        profileExtranet: initialState.profileExtranet,
      };

    default:
      return state;
  }
};

export default userProfile;
